var map = {
	"./10-12-2020-v2/1024/img/Wing_feathers_DiffuseColor.png": "fba1",
	"./10-12-2020-v2/2048/img/Wing_feathers_DiffuseColor.png": "1bbb",
	"./10-12-2020-v2/512/img/Wing_feathers_DiffuseColor.png": "e861",
	"./10-12-2020-v3/1024/img/Wing_feathers_DiffuseColor.png": "1385",
	"./10-12-2020-v3/2048/img/Wing_feathers_DiffuseColor.png": "0523",
	"./10-12-2020-v3/512/img/Wing_feathers_DiffuseColor.png": "7bb7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "88ee";